import React from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

interface UserMenuPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  user?: { name: string; email: string };
  onLogout: () => void;
}

const UserMenuPopover: React.FC<UserMenuPopoverProps> = ({ anchorEl, open, onClose, user, onLogout }) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    PaperProps={{ sx: { p: 2, minWidth: 220 } }}
  >
    <Box>
      <Typography variant="subtitle1">{user?.name || 'User Name'}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{user?.email || 'user@email.com'}</Typography>
      <Button onClick={onLogout} color="error" variant="contained" fullWidth sx={{ mb: 1 }}>Log out</Button>
      <Button onClick={onClose} fullWidth>Close</Button>
    </Box>
  </Popover>
);

export default UserMenuPopover;
